import React from 'react';
import { motion } from 'framer-motion';
export function TrialHero() {
  return <section className="bg-primary text-white py-16 md:py-24" data-id="element-285">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-287">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-288">
            Start Your Journey Today
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-8" data-id="element-289">
            Experience the benefits of martial arts with our exclusive
            introductory offer. No long-term commitment required.
          </p>
          <div className="inline-block bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20" data-id="element-290">
            <p className="text-2xl font-bold text-accent" data-id="element-291">
              4 WEEKS FOR $39 INCLUDING UNIFORM
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}